import React, { FC } from 'react';

interface GameInfoHeaderProps {
    potentialWord?: string;
    potentialScore?: number;
    time: number;
}

const GameInfoHeader: FC<GameInfoHeaderProps> = ({ potentialWord, potentialScore, time, children }) => {

    let text = '';
    if(potentialWord) {
        text = `${potentialWord} is worth ${potentialScore} points!`
    }
    else if(time <= 120 && time >= 118) {
        text = 'Two minutes left!'
    }
    else if(time <= 60 && time >= 58) {
        text = 'One minute left!'
    }
    else if(time <= 30 && time >= 28) {
        text = 'Thirty seconds left!'
    }
    else if(time <= 10 && time >= 8) {
        text = 'Ten seconds left!'
    }
    
    return (
        <header className="gameInfoHeader">
            &nbsp;
            {text}
        </header>

    );
};

export default GameInfoHeader;
